import DashboardButtons from '../../DashboardButtons'
import classes from '../DashboardItem.module.css'
import { useSelector } from "react-redux"
import { getWorkQBySlugMaster } from "../../../../lib/fetchApi"
import { useEffect, useState } from "react"
import { formatNumber, getItemFromStorageSimple } from "../../../../lib/script"
import { setBodyOnWorkQDashboard } from "../../../../lib/workQ"

export default function WorkQGeneralWidget({workq}) {
    const userToken = useSelector(state => state.user.token)
    const [workqData, setWorkqData] = useState(null)
    const [loading, setLoading] = useState(false)
    const userLocationsRedux = useSelector(state => state.user.userLocations)


    useEffect(() => {
        const userLocations = getItemFromStorageSimple('userLocations')
        async function fetchWorkQData(slug) {
            setLoading(true)
            let reqBody = {
                widget: true,
                // case_flags: {liability_pi_not_verified: true, mp_um_pi_auto_ins_not_verified: true, mm_not_verified: true},
                master_status: 1
            }
            let body = {}      
            body = setBodyOnWorkQDashboard(workq, slug) 
            reqBody = {
                ...reqBody,
                ...body
            }
            // if (userLocations) {
            //     reqBody.location = userLocations.join(",")
            // }
            const data = await getWorkQBySlugMaster(userToken, slug, reqBody)
            setWorkqData(data)
            setLoading(false)
        }
        if (workq && userToken) {
            fetchWorkQData(workq.slug)
        }
    }, [workq, userLocationsRedux])



    return <div className={classes.item_inner_box}>
        <div className={classes.item_header}>
            <div>
                <div className={classes.item_title}>
                    {workq.name}
                    {/* <InfoButton info={'different info to know that this is different'}/> */}
                </div>

                <div className={classes.description}>
                    {!loading && workqData && <>{formatNumber(workqData?.total)} total cases</>}
                    {loading && <div className={classes.loading}>Loading...</div>}
                </div>
            </div>
            <DashboardButtons workqSlug={workq.slug} caseId={workqData?.first_case_number ? workqData?.first_case_number : workqData?.first_case} workq={workq}/>
        </div>
    </div>
}